import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OneTrustService {
  public init(): void {
    const oneTrustScript = document.createElement('script');
    oneTrustScript.type = 'text/javascript';
    oneTrustScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    oneTrustScript.setAttribute('data-document-language', 'true');
    oneTrustScript.setAttribute('charset', 'UTF-8');
    oneTrustScript.setAttribute('data-domain-script', 'ac6afa08-7ba3-4da7-ad2b-b0a8fc4f6d84');
    oneTrustScript.setAttribute('data-document-language', 'true');

    document.head.insertBefore(oneTrustScript, document.head.firstChild);

    const optanonWrapper = document.createElement('script');
    oneTrustScript.type = 'text/javascript';
    optanonWrapper.appendChild(document.createTextNode('function OptanonWrapper() { }'));

    document.head.insertBefore(optanonWrapper, document.head.firstChild);
  }
}
